<template>
  <div>
    <div class="form-container">
      <ProgressBar :progressPercent="40" progressLabel="Step 2 of 5" />
      <h1 class="step-title">Insured Property</h1>
      <div class="row">
        <div class="col-md-3">
          <input
            type="text"
            class="form-control shadow-none"
            :value="two.propertyAddress.street"
            @input="updateAddress('street', $event.target.value)"
            placeholder="Mexican Street"
          />
          <div class="e-wrapper">
            <p
              v-if="!$v.two.propertyAddress.street.required"
              class="small required"
            >
              * Mexican Street Required
            </p>
          </div>
        </div>
        <div class="col-md-3">
          <input
            type="text"
            class="form-control shadow-none"
            :value="two.propertyAddress.city"
            @input="updateAddress('city', $event.target.value)"
            placeholder="Mexican City"
          />
          <div class="e-wrapper">
            <p
              v-if="!$v.two.propertyAddress.city.required"
              class="small required"
            >
              * Mexican City Required
            </p>
          </div>
        </div>
        <div class="col-md-3">
          <input
            type="text"
            class="form-control shadow-none"
            :value="two.propertyAddress.state"
            @input="updateAddress('state', $event.target.value)"
            placeholder="Mexican State"
          />
          <div class="e-wrapper">
            <p
              v-if="!$v.two.propertyAddress.state.required"
              class="small required"
            >
              * Mexican State Required
            </p>
          </div>
        </div>
        <div class="col-md-3">
          <input
            type="text"
            class="form-control shadow-none"
            :value="two.propertyAddress.zip"
            @input="updateAddress('zip', $event.target.value)"
            v-mask="'##### - ####'"
            placeholder="Mexican Zip Code"
          />
          <div class="e-wrapper">
            <p
              v-if="!$v.two.propertyAddress.zip.required"
              class="small required"
            >
              * Mexican Zip Required
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input
            type="text"
            class="form-control shadow-none"
            :value="two.mexicanPhone"
            @input="updateField('mexicanPhone', $event.target.value)"
            v-mask="' 011 52 (###) ###-####'"
            placeholder="Mexican Phone"
          />
        </div>
        <div class="col-md-6">
          <input
            type="text"
            class="form-control shadow-none"
            :value="two.mexicanMunicipality"
            @input="updateField('mexicanMunicipality', $event.target.value)"
            placeholder="Municipality"
          />
        </div>
      </div>
    </div>
    <div class="step-buttons">
      <button class="btn btn-primary" type="button" @click="prev()">
        Previous
      </button>
      <button class="btn btn-primary" type="button" @click="next()">
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import ProgressBar from "./ProgressBar";

export default {
  components: { ProgressBar },
  computed: {
    ...mapState(["two"]),
  },
  validations: {
    two: {
      propertyAddress: {
        street: {
          required,
        },
        state: {
          required,
        },
        city: {
          required,
        },
        zip: {
          required,
        },
      },
    },
  },
  methods: {
    ...mapActions(["updateFormTwo", "nextStep", "prevStep"]),
    updateField(key, val) {
      const updates = { [key]: val };
      this.updateFormTwo(updates);
    },
    updateAddress(key, val) {
      const updatedAddress = { ...this.two.propertyAddress, [key]: val };
      this.updateFormTwo({ propertyAddress: updatedAddress });
    },
    prev() {
      window.scrollTo(0, 0);
      this.prevStep();
    },
    next() {
      window.scrollTo(0, 0);
      if (this.$v.$invalid) {
        return;
      }
      this.nextStep();
    },
  },
};
</script>

<style></style>
